// extracted by mini-css-extract-plugin
export var buttonSection = "tag-page-module--button-section--zy6-7";
export var headingSection = "tag-page-module--heading-section--2mL5S";
export var headingSectionWrapper = "tag-page-module--heading-section-wrapper--gSD0Y";
export var layout = "tag-page-module--layout--ISw0Y";
export var subtitle = "tag-page-module--subtitle--i29A5";
export var title = "tag-page-module--title--RoUTa";